import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_SALP_PERSONAL_STORY_TOGGLE = defineFcm('starfish_salp_personal_story_toggle')
	.asBoolean()
	.withDefault(false)
	.withMerger(({ localeValue, countryValue }) => localeValue && countryValue)
	.toConfig();
